<template>
  <div class="simple-flight-chart">
    <div class="chart-container" ref="chartContainer"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'SimpleFlightChart',
  props: {
    investmentData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      myChart: null,
      
      // 广东主要城市
      guangdongCities: [
        { name: '广州', coords: [113.23, 23.16], value: 100 },
        { name: '深圳', coords: [113.46, 22.27], value: 95 },
        { name: '佛山', coords: [113.06, 23.02], value: 85 },
        { name: '东莞', coords: [113.45, 23.02], value: 80 },
        { name: '惠州', coords: [114.23, 23.05], value: 70 },
        { name: '珠海', coords: [113.35, 22.17], value: 65 },
        { name: '中山', coords: [113.20, 22.31], value: 60 },
        { name: '江门', coords: [113.01, 22.35], value: 55 },
        { name: '肇庆', coords: [112.27, 23.03], value: 50 },
        { name: '汕头', coords: [116.69, 23.35], value: 45 }
      ],
      
      // 湖南主要城市
      hunanCities: [
        { name: '长沙', coords: [112.59, 28.12], value: 100 },
        { name: '株洲', coords: [113.10, 27.50], value: 80 },
        { name: '湘潭', coords: [112.55, 27.52], value: 75 },
        { name: '衡阳', coords: [112.34, 26.54], value: 70 },
        { name: '岳阳', coords: [113.05, 29.22], value: 65 },
        { name: '常德', coords: [111.51, 29.02], value: 60 },
        { name: '郴州', coords: [113.02, 25.46], value: 55 },
        { name: '益阳', coords: [112.20, 28.36], value: 50 },
        { name: '永州', coords: [111.37, 26.13], value: 45 },
        { name: '怀化', coords: [110.00, 27.33], value: 40 }
      ],
      
      // 投资流向数据
      investmentFlows: []
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.dispose();
    }
  },
  methods: {
    initChart() {
      this.myChart = echarts.init(this.$refs.chartContainer);
      this.generateInvestmentData();
      this.renderChart();
    },
    
    generateInvestmentData() {
      const flows = [];
      
      // 主要投资流向（模拟数据）
      const mainFlows = [
        { from: '广州', to: '长沙', value: 90 },
        { from: '深圳', to: '长沙', value: 85 },
        { from: '佛山', to: '长沙', value: 80 },
        { from: '东莞', to: '长沙', value: 75 },
        { from: '广州', to: '株洲', value: 70 },
        { from: '深圳', to: '湘潭', value: 65 },
        { from: '佛山', to: '衡阳', value: 60 },
        { from: '东莞', to: '岳阳', value: 55 },
        { from: '广州', to: '常德', value: 50 },
        { from: '深圳', to: '郴州', value: 45 },
        { from: '惠州', to: '长沙', value: 40 },
        { from: '珠海', to: '株洲', value: 35 },
        { from: '中山', to: '湘潭', value: 30 },
        { from: '江门', to: '衡阳', value: 25 }
      ];
      
      mainFlows.forEach(flow => {
        const fromCity = this.guangdongCities.find(city => city.name === flow.from);
        const toCity = this.hunanCities.find(city => city.name === flow.to);
        
        if (fromCity && toCity) {
          flows.push({
            from: flow.from,
            to: flow.to,
            value: flow.value,
            fromCoords: fromCity.coords,
            toCoords: toCity.coords
          });
        }
      });
      
      this.investmentFlows = flows;
    },
    
    renderChart() {
      const option = {
        backgroundColor: '#1a1a2e',
        title: {
          text: '202*年广东上市公司在湖南省投资数据统计',
          subtext: '广东省各城市 → 湖南省各城市投资流向图',
          left: 'center',
          top: 10,
          textStyle: {
            color: '#fff',
            fontSize: 20,
            fontWeight: 'bold'
          },
          subtextStyle: {
            color: '#aaa',
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#ff4d4f',
          textStyle: { 
            color: '#fff',
            fontSize: 12
          },
          formatter: params => {
            if (params.seriesType === 'lines') {
              const data = params.data;
              return `
                <div style="margin-bottom: 5px; font-weight: bold; color: #ff4d4f;">投资流向</div>
                <div>投资来源：${data.from}</div>
                <div>投资目的地：${data.to}</div>
                <div>投资强度：<span style="color: #ff9a3c; font-weight: bold;">${data.value}</span></div>
              `;
            } else if (params.seriesType === 'scatter') {
              return `<div>${params.name}</div>`;
            }
            return params.name;
          }
        },
        // 双地图配置
        geo: [
          {
            // 广东地图
            map: '广东',
            left: '5%',
            top: '20%',
            width: '40%',
            height: '60%',
            label: {
              show: true,
              color: '#fff',
              fontSize: 10
            },
            itemStyle: {
              areaColor: '#1e6f5c',
              borderColor: '#fff',
              borderWidth: 1
            },
            emphasis: {
              itemStyle: {
                areaColor: '#2a9d8f'
              },
              label: {
                fontWeight: 'bold',
                color: '#fff'
              }
            },
            zoom: 1.1
          },
          {
            // 湖南地图
            map: '湖南',
            right: '5%',
            top: '20%',
            width: '40%',
            height: '60%',
            label: {
              show: true,
              color: '#fff',
              fontSize: 10
            },
            itemStyle: {
              areaColor: '#b83b5e',
              borderColor: '#fff',
              borderWidth: 1
            },
            emphasis: {
              itemStyle: {
                areaColor: '#e8457f'
              },
              label: {
                fontWeight: 'bold',
                color: '#fff'
              }
            },
            zoom: 1.1
          }
        ],
        series: [
          {
            // 飞线系列
            name: '投资流向',
            type: 'lines',
            polyline: false,
            coordinateSystem: null,
            data: this.investmentFlows.map(flow => ({
              fromName: flow.from,
              toName: flow.to,
              coords: [flow.fromCoords, flow.toCoords],
              value: flow.value,
              lineStyle: {
                color: '#ff4d4f',
                width: Math.max(1, flow.value / 20), // 投资金额越大，线越粗
                curveness: 0.2,
                opacity: 0.8
              }
            })),
            emphasis: {
              lineStyle: {
                width: 4,
                opacity: 1
              }
            },
            effect: {
              show: true,
              period: 5,
              trailLength: 0.1,
              symbol: 'arrow',
              symbolSize: 8,
              color: '#ff9a3c'
            },
            label: {
              show: false
            },
            zlevel: 2
          },
          {
            // 广东城市点
            name: '广东城市',
            type: 'scatter',
            coordinateSystem: null,
            geoIndex: 0,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              color: '#1e6f5c',
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              scale: 1.5
            },
            data: this.guangdongCities
          },
          {
            // 湖南城市点
            name: '湖南城市',
            type: 'scatter',
            coordinateSystem: null,
            geoIndex: 1,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              color: '#b83b5e',
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              scale: 1.5
            },
            data: this.hunanCities
          },
          {
            // 城市标签
            type: 'scatter',
            coordinateSystem: null,
            geoIndex: 0,
            symbol: 'none',
            label: {
              show: true,
              position: 'right',
              formatter: '{b}',
              color: '#fff',
              fontSize: 10,
              fontWeight: 'bold'
            },
            data: this.guangdongCities
          },
          {
            // 城市标签
            type: 'scatter',
            coordinateSystem: null,
            geoIndex: 1,
            symbol: 'none',
            label: {
              show: true,
              position: 'right',
              formatter: '{b}',
              color: '#fff',
              fontSize: 10,
              fontWeight: 'bold'
            },
            data: this.hunanCities
          }
        ],
        legend: {
          show: false
        },
        visualMap: {
          type: 'continuous',
          min: 20,
          max: 100,
          calculable: true,
          inRange: {
            color: ['#ff7e5f', '#feb47b']
          },
          textStyle: {
            color: '#fff'
          },
          right: 20,
          bottom: 20,
          orient: 'vertical',
          text: ['投资强度', ''],
          dimension: 2
        }
      };
      
      this.myChart.setOption(option);
      
      // 加载地图数据
      this.loadMapData();
    },
    
    loadMapData() {
      let guandong  = 'map/guangdong.json';
      let hunan = 'map/hunan.json';
      console.log('加载地图数据', guandong, hunan);
      return;
      // 异步加载地图数据
      Promise.all([
        fetch('map/guangdong.json').then(res => res.json()),
        fetch('map/hunan.json').then(res => res.json())
      ]).then(([guangdongMap, hunanMap]) => {
        echarts.registerMap('广东', guangdongMap);
        echarts.registerMap('湖南', hunanMap);
        this.myChart.setOption({
          geo: [
            { map: '广东' },
            { map: '湖南' }
          ]
        });
      }).catch(error => {
        console.error('加载地图数据失败:', error);
        // 如果没有地图数据，使用散点图模式
        this.fallbackToScatter();
      });
    },
    
    fallbackToScatter() {
      // 如果没有地图数据，使用散点图模式
      const option = {
        ...this.myChart.getOption(),
        geo: [],
        series: [
          {
            name: '投资流向',
            type: 'lines',
            polyline: false,
            coordinateSystem: null,
            data: this.investmentFlows.map(flow => ({
              fromName: flow.from,
              toName: flow.to,
              coords: [flow.fromCoords, flow.toCoords],
              value: flow.value,
              lineStyle: {
                color: '#ff4d4f',
                width: Math.max(1, flow.value / 20),
                curveness: 0.2,
                opacity: 0.8
              }
            })),
            emphasis: {
              lineStyle: {
                width: 4,
                opacity: 1
              }
            },
            effect: {
              show: true,
              period: 5,
              trailLength: 0.1,
              symbol: 'arrow',
              symbolSize: 8,
              color: '#ff9a3c'
            }
          },
          {
            name: '广东城市',
            type: 'scatter',
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: {
              color: '#1e6f5c',
              borderColor: '#fff',
              borderWidth: 2
            },
            data: this.guangdongCities.map(city => ({
              name: city.name,
              value: city.coords,
              symbolSize: 12
            }))
          },
          {
            name: '湖南城市',
            type: 'scatter',
            symbol: 'circle',
            symbolSize: 10,
            itemStyle: {
              color: '#b83b5e',
              borderColor: '#fff',
              borderWidth: 2
            },
            data: this.hunanCities.map(city => ({
              name: city.name,
              value: city.coords,
              symbolSize: 12
            }))
          }
        ]
      };
      
      this.myChart.setOption(option, true);
    }
  }
};
</script>

<style scoped>
.simple-flight-chart {
  width: 100%;
  height: 100%;
  min-height: 600px;
  position: relative;
  background-color: #1a1a2e;
  border-radius: 8px;
  overflow: hidden;
}

.chart-container {
  width: 100%;
  height: 100%;
  min-height: 600px;
}
</style>